import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import moment from "moment";
import "./MedicationAdherence.css";

const MedicationAdherenceList = ({ ...props }) => {
  // const dateFormatter = (cell, row) => {
  //   return `${moment(row.eventTimestamp).format("MMM/DD/YYYY")}   ${moment(
  //     row.eventTimestamp
  //   ).format("hh:mm A")}`;
  // };

  const srNumberFormatter = (cell, row, rowIndex) => {
    if (props.currentPage > 1)
      return <>{props.perPage * (props.currentPage - 1) + (rowIndex + 1)}</>;
    else return <>{rowIndex + 1}</>;
  };
  const strengthFormatter = (cell, row) => {
    return (
      <span>
        {" "}
        {row?.doseStrength} {row?.doseUnit}
      </span>
    );
  };
  const dateFormatter = (cell, row) => {
    return `${moment(row?.timeToTake).format("MM/DD/YYYY")}  |  ${moment(row?.timeToTake).format("hh:mm A")}`;
  };
  const doseTakenFormatter = (cell, row) => {
    if (row?.doseStatus === 'T') return <span>Yes</span>;
    else return <span>-</span>;
  };
  const skipReasonFormatter = (cell, row) => {
    if (row?.doseStatus === 'S') return <span>{row.skipReason}</span>;
    else return <span>-</span>;
  };
  const doseIgnoredFormatter = (cell, row) => {
    if (row?.doseStatus === 'I') return <span>Yes</span>;
    else return <span>-</span>;
  };
  const columns = [
    {
      dataField: "id",
      text: "No.",
      formatter: srNumberFormatter,
      headerStyle: () => {
        return { width: "48px", paddingLeft: "28px" };
      },
    },
    {
      dataField: "medicationName",
      text: "MEDICATION NAME",
    },
    {
      dataField: "doseStrength",
      text: "STRENGTH",
      formatter: strengthFormatter,
      headerStyle: () => {
        return { width: "64px" };
      },
    },
    // {
    //   dataField: "doseUnit",
    //   text: "UNIT",

    // },
    {
      dataField: "timeToTake",
      text: "TIME TO TAKE",
      formatter: dateFormatter,
    },
    {
      dataField: "doseTaken",
      text: "DOSE TAKEN",
      headerStyle: () => {
        return { width: "164px" };
      },
      formatter: doseTakenFormatter,
    },
    {
      dataField: "skipReason",
      text: "SKIP REASON",
      formatter: skipReasonFormatter,
    },
    {
      dataField: "isIgnored",
      text: "DOSE IGNORED",
      formatter: doseIgnoredFormatter,
    },
    //  {
    //   dataField: "notes1",
    //   text: "NOTES",
    //   formatter: notesFormatter,
    //   events: {
    //     onClick: (e, column, columnIndex, row, rowIndex) => {
    //       handleShowNotesModal(true, row);
    //     }
    //   },
    // },
  ];

  return (
    <>
      <div className="medication-adherence-list">
        <BootstrapTable
          keyField="id"
          data={props.medicationAdherenceList?.length ? props.medicationAdherenceList?.sort((t1, t2) => {
            if (t1.timeToTake > t2.timeToTake) return -1;
            if (t1.timeToTake < t2.timeToTake) return 1;
            return 0;
          }) : []}
          columns={columns}
          striped
          hover
          condensed
          bordered={false}
        />
      </div>
    </>);
};

export default MedicationAdherenceList;
